import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { callDealCouponGetApi, callDealCouponSourcesApi } from "../Context/dealCouponApi";
import { onGetDealCoupon, onGetDealCouponError, onGetDealCouponSources, onGetDealCouponSourcesError, onGetDealCouponSourcesSuccess, onGetDealCouponSuccess } from "../Store/Slices/dealCouponSlice";

function* GetDealCoupon({ payload }) {
  try {
    const getDealCouponResponse = yield call(callDealCouponGetApi, payload);
    if (getDealCouponResponse.responseCode === "200") {
      yield put(
        onGetDealCouponSuccess({
          data: getDealCouponResponse.response,
          message: getDealCouponResponse.responseMessage,
          status_code: getDealCouponResponse.responseCode
        })
      );
    } else {
      yield put(
        onGetDealCouponError({
          data: getDealCouponResponse.response,
          message: getDealCouponResponse.response.message,
          status_code: getDealCouponResponse.responseCode
        })
      );
    }
  } catch (error) {
    const message = error.response || "Something went wrong";
    yield put(onGetDealCouponError({ data: [], message, status_code: 400 }));
  }
}

function* GetDealCouponSources({ payload }) {
  try {
    const response = yield call(callDealCouponSourcesApi, payload.payload);
    if (response.responseCode === "200") {
      yield put(onGetDealCouponSourcesSuccess(response.response));
      payload?.resolve(response.response);
      return;
    } else {
      yield put(onGetDealCouponSourcesError());
      payload?.resolve(null);//force resolve even on failure
      return;
    }
  } catch (error) {
    yield put(onGetDealCouponSourcesError());
    payload?.resolve(null);
    return;
  }
}

export default function* dealCouponSaga() {
  yield takeLatest(onGetDealCoupon.type, GetDealCoupon);
  yield takeEvery(onGetDealCouponSources.type, GetDealCouponSources);
}
